import { NmsWizardStepModel } from "@nms-angular-toolkit/nms-wizard";
import { TemplateOptions } from "./template.interface";

/**
 * Representa o modelo para criação de Templates na primeira página.
 * Como não estamos utilizando essses valores para salvar os dados,
 * algumas variáveis não foram tipadas e estão definidas como any.
 * Já temos uma US [US-14641] mapeada para reestruturar o código de templates
 * para utilizar a estrutura correta da wizard.
 * Provavelmente nesse ponto os dados serão tipados e utilizados
 * da forma correta.
 */
export class TemplateStepBasicModel extends NmsWizardStepModel {
    id?: string;
    templateType: string;
    templateLanguage: string;
    templateName: string;
    description: string;
    isNmsTemplate: boolean;
    hasTemplateConfigPermission: boolean;
    status: string;
    used: boolean;
    matchingRules: any;
}

/**
 * Representa o modelo para criação de Templates na segunda página.
 * Como não estamos utilizando essses valores para salvar os dados,
 * algumas variáveis não foram tipadas e estão definidas como any.
 * Já temos uma US [US-14641] mapeada para reestruturar o código de templates
 * para utilizar a estrutura correta da wizard.
 * Provavelmente nesse ponto os dados serão tipados e utilizados
 * da forma correta.
 */
export class TemplateStepCommandsModel extends NmsWizardStepModel {
    applyCommands: string;
    removeCommandsEnabled: boolean;
    removeCommands: string;
    equipmentRestrictionFilter: any;
    restrictTemplate: any;
    applicationNameSuggestionModel: any;
    keepAlive: boolean;
    variableTypes: any;
    cliCommandOptionExtractionFilterTypes: any;
    commandTest: any;
    advancedOptions: any;
    templateTypeDefault: any;
    templateOptions: TemplateOptions;
}
